import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ComponentBase } from '../../../_infrastructure/classes/componentBase';
import { UntypedFormBuilder } from '@angular/forms';
import { Table } from 'primeng/table';
import { GlobalService } from '../../../_infrastructure/classes/services/global.service';
import { Dialog } from 'primeng/dialog';
import {
    FilterSearchingRegEntidadAuditoraViewModel,
    RegEntidadAuditoraItemResultsViewModel,
    RegEntidadAuditoraItemViewModel,
} from '../../../../_mantenimiento/registros/entidadesauditoras/entidadauditora.types';
import { Observable } from 'rxjs';
import { EnumSiNoTodos, Tc } from '../../../_infrastructure/types/common';
import { CustomValidator } from '../../../_infrastructure/classes/customValidator';
import { EntidadAuditoraService } from '../../../../_mantenimiento/registros/entidadesauditoras/entidadauditora.service';

@Component({
    selector: 'app-entidad-auditora-popup',
    templateUrl: './entidadAuditoraPopup.component.html',
})
export class EntidadAuditoraPopupComponent extends ComponentBase implements OnInit {
    @Output() entidadAuditoraEmitter = new EventEmitter<RegEntidadAuditoraItemViewModel>();

    @ViewChild('tableSearch') turboTable: Table;
    resultEntidadAuditora: RegEntidadAuditoraItemResultsViewModel;
    listProvincias: Tc[];
    display = false;
    cols: any[];
    selectedEntidadAuditora: RegEntidadAuditoraItemViewModel | null;
    isCollapsed = false;
    IdCampania = 0;

    constructor(private fb: UntypedFormBuilder, private globalService: GlobalService, private entidadAuditoraService: EntidadAuditoraService) {
        super();
    }

    ngOnInit() {
        this.globalService.getProvincias().subscribe(res => {
            this.listProvincias = res;
        });

        this.cols = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'Nombre', header: 'Nombre Representante' },
            { field: 'Apellidos', header: 'Apellidos Representante' },
            { field: 'NIF', header: 'NIF/EORI Representante' },
            { field: 'RazonSocial', header: 'Razón Social' },
            { field: 'NIFRazonSocial', header: 'NIF Razón Social' },
            { field: 'IdProvinciaRazonSocialDescripcion', header: 'Provincia Razón Social' },
            { field: 'CodigoPostalRazonSocial', header: 'C.P. Razón Social' },
            { field: 'DireccionRazonSocial', header: 'Dirección Razón Social' },
            { field: 'LocalidadRazonSocial', header: 'Localidad Razón Social' },
            { field: 'NombrePersonaContacto', header: 'Nombre Persona Contacto' },
            { field: 'ApellidosPersonaContacto', header: 'Apellidos Persona Contacto' },
            { field: 'EmailPersonaContacto', header: 'Email Persona Contacto' },
            { field: 'Activa', header: 'Activa' },
        ];

        this.form = this.fb.group({
            Nombre: null,
            Apellidos: '',
            NIF: ['', CustomValidator.NIFValidator],
            RazonSocial: '',
            NIFRazonSocial: ['', CustomValidator.NIFValidator],
            IdProvinciaRazonSocial: null,
            LocalidadRazonSocial: '',
            NombrePersonaContacto: '',
            ApellidosPersonaContacto: '',
            Activa: EnumSiNoTodos.SI, //--POR DEFECTO SOLO FILTRO LOS ACTIVOS
        });
    }

    onSearchButton() {
        if (this.turboTable) {
            this.turboTable.first = 0;
        }

        this.Search(0);

        this.entidadAuditoraService.currentFilter.Nombre = this.form.value.Nombre;
        this.entidadAuditoraService.currentFilter.Apellidos = this.form.value.Apellidos;
        this.entidadAuditoraService.currentFilter.NIF = this.form.value.NIF;

        this.entidadAuditoraService.currentFilter.RazonSocial = this.form.value.RazonSocial;
        this.entidadAuditoraService.currentFilter.NIFRazonSocial = this.form.value.NIFRazonSocial;
        this.entidadAuditoraService.currentFilter.IdProvinciaRazonSocial = this.form.value.IdProvinciaRazonSocial;
        this.entidadAuditoraService.currentFilter.LocalidadRazonSocial = this.form.value.LocalidadRazonSocial;
        this.entidadAuditoraService.currentFilter.Activa = EnumSiNoTodos.SI; //--POR DEFECTO SOLO FILTRO LOS ACTIVOS
        this.entidadAuditoraService.currentFilter.NombrePersonaContacto = this.form.value.NombrePersonaContacto;
        this.entidadAuditoraService.currentFilter.ApellidosPersonaContacto = this.form.value.ApellidosPersonaContacto;
        this.entidadAuditoraService.currentFilter.IdCampania = this.IdCampania;
        this.searchingButton = true;
        this.isCollapsed = true;
    }

    Search(pageNumber: number, asc = -1, orderBy = 'Nombre') {
        this.loading = true;

        let model: FilterSearchingRegEntidadAuditoraViewModel = this.CreateModel();

        model.PageNumber = pageNumber;
        model.Asc = asc;
        model.OrderBy = orderBy;

        this.entidadAuditoraService.postGetPagedByFilter(model).subscribe(res => {
            this.resultEntidadAuditora = res;

            this.loading = false;
        });
    }

    onSearchLazy(event: any) {
        if (!event.rows) {
            return;
        }

        let pageNumber = event.first / event.rows;
        this.Search(pageNumber, event.sortOrder, event.sortField);
    }

    onCleanButton() {
        this.form.setValue({
            Nombre: null,
            Apellidos: '',
            NIF: '',
            RazonSocial: '',
            NIFRazonSocial: '',
            IdProvinciaRazonSocial: null,
            LocalidadRazonSocial: '',
            NombrePersonaContacto: '',
            ApellidosPersonaContacto: '',
            Activa: EnumSiNoTodos.SI,
        });

        this.searchingButton = false;
        this.isCollapsed = false;
    }

    CreateModel() {
        let model: FilterSearchingRegEntidadAuditoraViewModel = new FilterSearchingRegEntidadAuditoraViewModel();

        Object.assign(model, this.form.value);
        //añado al filtro el IdCampania
        model.IdCampania = this.IdCampania;

        return model;
    }

    showDialog(idCampania: number): void {
        this.display = true;
        this.IdCampania = idCampania;
    }

    onRowDblClick(event: any, entidadAuditora: RegEntidadAuditoraItemViewModel): void {
        this.display = false;
        this.entidadAuditoraEmitter.emit(entidadAuditora);
    }

    acceptDialog(): void {
        this.display = false;
        this.entidadAuditoraEmitter.emit(this.selectedEntidadAuditora!);
    }

    cancelDialog(): void {
        this.display = false;
    }

    showDialogMaximized(dialog: Dialog): void {
        setTimeout(() => {
            dialog.maximize();
        }, 0);
    }

    onSelect(selection: RegEntidadAuditoraItemViewModel): void {
        this.selectedEntidadAuditora = selection;
    }

    noAccepted(): boolean {
        return !this.form.valid || !this.selectedEntidadAuditora;
    }
}
